export const searchParams = {
  BASE_URL: 'https://pixabay.com/api/',
  API_KEY: '31555510-20bee98b1f3b8ae280fb0cd2b',
  IMAGE_TYPE: 'photo',
  ORIENTATION: 'horizontal',
  PER_PAGE: 12,
};

export const notificationParams = {
  position: 'top-right',
  autoClose: 2000,
  theme: 'colored',
};
